module.exports = __webpack_public_path__ + "assets/images/ert_news.d012a9965042c92b7d1e0bc5e6089d11.png";